/**
 * useTheme.jsx
 * Dark/light toggle. Dark is the default — the app was designed for it.
 *
 * The choice is stamped on <html data-theme> and remembered per browser.
 * Storage is wrapped because private windows and blocked site data can throw.
 */

import { useCallback, useEffect, useState } from 'react';

const KEY = 'kreeboom.theme';

const read = () => {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
};

export function useTheme() {
  const [theme, setTheme] = useState(() => read() ?? 'dark');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    try {
      localStorage.setItem(KEY, theme);
    } catch {
      /* nothing we can do, and nothing that matters */
    }
  }, [theme]);

  const toggle = useCallback(() => setTheme((t) => (t === 'dark' ? 'light' : 'dark')), []);

  return { theme, toggle };
}
